import { api } from '../configs/apiConfig';

class DesktopAccessControlService {
    // Get all access controls
    async getAllAccessControls() {
        try {
            const response = await api.get('/DesktopAccessControl');
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get access control by ID
    async getAccessControlById(id) {
        try {
            const response = await api.get(`/DesktopAccessControl/${id}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get access controls by desktop ID - returns detailed information
    async getAccessControlsByDesktop(desktopId) {
        try {
            const response = await api.get(`/DesktopAccessControl/desktop/${desktopId}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get access controls by user ID
    async getAccessControlsByUser(userId) {
        try {
            const response = await api.get(`/DesktopAccessControl/user/${userId}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get access controls by organizational unit ID
    async getAccessControlsByUnit(unitId) {
        try {
            const response = await api.get(`/DesktopAccessControl/unit/${unitId}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Create new access control
    async createAccessControl(accessControlData) {
        try {
            const response = await api.post('/DesktopAccessControl', accessControlData);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Update existing access control
    async updateAccessControl(id, accessControlData) {
        try {
            const response = await api.put(`/DesktopAccessControl/${id}`, accessControlData);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Delete access control
    async deleteAccessControl(id) {
        try {
            await api.delete(`/DesktopAccessControl/${id}`);
            return true;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Check if user has access to a desktop
    async checkAccess(userId, desktopId) {
        try {
            const response = await api.get(`/DesktopAccessControl/check-access?userId=${userId}&desktopId=${desktopId}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Get all accessible desktops for a user
    async getAccessibleDesktops(userId) {
        try {
            const response = await api.get(`/DesktopAccessControl/accessible-desktops/${userId}`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    // Helper method to handle errors
    handleError(error) {
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            return {
                status: error.response.status,
                message: error.response.data.message || 'An error occurred',
                data: error.response.data
            };
        } else if (error.request) {
            // The request was made but no response was received
            return {
                status: 0,
                message: 'No response from server',
                data: null
            };
        } else {
            // Something happened in setting up the request that triggered an Error
            return {
                status: 0,
                message: error.message,
                data: null
            };
        }
    }
}

export default new DesktopAccessControlService(); 